import React from "react";
import StartStep from "../../components/StartStep/StartStep";
import GreyCard from "../../components/GreyCard/GreyCard";
import Row from "react-bootstrap/Row";
import {Button, Col, ProgressBar} from "react-bootstrap";
import Container from "react-bootstrap/Container";

const AboutUs = () => {
    return (
        <div>
            <StartStep>
                <h1>Единый личный кабинет (ЕЛК) </h1>
            </StartStep>

            <GreyCard>
                <p>
                    <b>Единый личный кабинет (ЕЛК)</b> – это цифровая экосистема НИУ ВШЭ, интеллектуальная среда
                    взаимодействия пользователей.
                </p>
                <br/>
                <p>
                    ЕЛК имеет удобный и современный дизайн, учитывает потребности каждого пользователя в необходимой ему
                    информации, а также интегрирован с <a href="https://www.mos.ru/">порталом услуг города Москвы</a>.
                </p>
                <br/>
                <p>Специальных действий для установки системы не требуется.</p>
                <br/>
                <p>
                    Для использования ЕЛК необходим компьютер или мобильное устройство, подключенные к сети Интернет, и
                    любой браузер (рекомендуется Google Chrome). Для начала работы с системой необходимо запустить
                    браузер и указать адрес <a href="https://lk.hse.ru/">https://lk.hse.ru/</a>.
                </p>
                <br/>
                <p>
                    Обратите, пожалуйста, внимание, что при использовании беспроводной сети Интернет вашим оператором
                    сотовой связи может взиматься дополнительная плата – мы рекомендуем пользоваться
                    <a href="https://it.hse.ru/internet">Wi-Fi</a>.
                </p>
                <br/>
                <p>
                    Работники НИУ ВШЭ могут авторизоваться в ЕЛК по корпоративному логину и паролю.
                </p>
                <br/>
                <p>
                    Регистрация в информационных системах НИУ ВШЭ с целью получения корпоративного логина и пароля
                    производится при подаче документов в <a href="https://ep.hse.ru/">Единую приемную</a>, а также при заблаговременном создании заявок в
                    ЕЛК авторизованным в системе работником НИУ ВШЭ.
                </p>
                <br/>
                <p><a href="https://it.hse.ru/lk">Единый личный кабинет</a></p>
            </GreyCard>

            <br/><br/>

            <Container>
                <Row className="justify-content-md-center">
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step4">Назад</Button>{' '}
                    </Col>
                    <Col md={1}></Col>
                    <Col md={6} style={{ textAlign: "center", paddingTop: "6px"}}>
                        <ProgressBar now={45}/>
                        <span>Шаг 5 из 11</span>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step6">Вперед</Button>{' '}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AboutUs;